
<!--  -->
<template>
    <div class='trialRow' @click="showWxCode" :padding="padding">
        <Poptip placement="left" width="118" class="pop">
            <div class="trails">
                <div class="trailsStar">
                    <span class="iconfont icon-jifen"></span>
                </div>
                <div>免费</div>
                <div>体验</div>
            </div>
            <div  style="width:110px;margin:0 auto;" slot="content">
                <img :src="wxsrc"  class="trailcode"/>
            </div>
        </Poptip>

    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
    //这里存放数据
        return {
            padding:'8px 8px',
           isShowWxCode:false,
           wxsrc:require('../../../assets/images/showProduct/wx-code1.png')
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        showWxCode(){
            this.isShowWxCode = !this.isShowWxCode
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>

<style src="../pc.css" scoped></style>
<style src="../phone.css" scoped></style>
